import { useMemo, useState } from "react";

import { OBJECT_TYPE, REGEX } from "~/core/constants/common";
import { sanitizeCompanyDomainFromTextOrUrl } from "~/core/generic/common-utils";

import { SearchObjectsResponse } from "~/components/GlobalCommandbar/types/common";

import { createCompany } from "~/lib/database/company-data";

import { AccountLabel } from "../components/FormItems/AccountLabel";
import { useGlobalNewOpportunityModalContext } from "../context";
import { useGlobalCreateOpportunityStore } from "../store";

export const useAddAccount = (inputValue: string) => {
  const [addingNewAccount, setAddingNewAccount] = useState(false);

  const setAccounts = useGlobalCreateOpportunityStore(
    state => state.setAccounts,
  );
  const setSelectedAccount = useGlobalCreateOpportunityStore(
    state => state.setSelectedAccount,
  );

  const isValidDomain = useMemo(() => {
    return REGEX.DOMAIN.test(
      sanitizeCompanyDomainFromTextOrUrl(inputValue) || "",
    );
  }, [inputValue]);

  const { form, amountRef } = useGlobalNewOpportunityModalContext();

  const handleOnAddAccount = async () => {
    if (!isValidDomain) return;
    setAddingNewAccount(true);

    try {
      const { data } = await createCompany({
        company_domain: sanitizeCompanyDomainFromTextOrUrl(
          inputValue,
        ) as string,
      });

      if (data.data) {
        const newAccountData: SearchObjectsResponse = {
          object_id: data.data.id,
          image_url: data.data.company_logo,
          title: data.data.company_name,
          description: data.data.company_domain,
          object_type: OBJECT_TYPE.ACCOUNT,
        };
        setAccounts([
          {
            id: newAccountData.object_id,
            label: <AccountLabel item={newAccountData} />,
            active: true,
            searchableText: newAccountData.title || newAccountData.description,
            metadata: {
              description: newAccountData.description,
              title: newAccountData.title || newAccountData.description,
              image_url: newAccountData.image_url,
            },
          },
        ]);
        setTimeout(() => {
          form?.setFieldsValue({
            opportunity_account: newAccountData.object_id,
          });
          setSelectedAccount({
            id: newAccountData.object_id,
            label: <AccountLabel item={newAccountData} />,
            active: true,
            searchableText: newAccountData.title || newAccountData.description,
            metadata: {
              description: newAccountData.description,
              title: newAccountData.title || newAccountData.description,
              image_url: newAccountData.image_url,
            },
          });
          amountRef?.current?.focus();
        }, 100);
      }
    } catch (error) {
      console.error(error);
    }
    setAddingNewAccount(false);
  };

  return { handleOnAddAccount, addingNewAccount, isValidDomain };
};
